<template>
    <div class="text-body-1">
        <h1 class="text-h4">{{ info.name }}</h1>
        <supplier-name-label v-if="isTO1" class="pt-1 text-h6" :supplier-name="supplierName" />
        <slot name="bookingInfo" />
        <component
            :is="!$breakpoint.smAndDown ? 'product-gallery' : 'product-gallery-mobile'"
            v-if="info.images && info.images.length"
            :images-data="info.images"
            class="my-5"
        />
        <v-row class="my-6">
            <v-col v-if="info.description && info.description[locale]" cols="12" class="py-0">
                <h6 class="text-h6">
                    {{ $t('description') }}
                </h6>
                <div v-html="info.description[locale]" />
            </v-col>
            <slot name="offerInfo" />
            <v-col v-if="includedInfo" cols="12" md="6" lg="4">
                <h6 class="text-h6 text-success pb-1 pb-sm-3">
                    {{ $t('included') }}
                </h6>
                <div
                    style="white-space: pre-line"
                    :class="{'pl-5': /<ol>|<ul>/.test(includedInfo)}"
                    v-html="includedInfo"
                />
            </v-col>
            <v-col v-if="notIncludedInfo" cols="12" md="6" lg="4">
                <h6 class="text-h6 text-error pb-1 pb-sm-3">
                    {{ $t('not_included') }}
                </h6>
                <div
                    style="white-space: pre-line"
                    :class="{'pl-5': /<ol>|<ul>/.test(notIncludedInfo)}"
                    v-html="notIncludedInfo"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import ProductGallery from '@/components/info/ProductGallery.vue'
    import ProductGalleryMobile from '@/components/info/ProductGalleryMobile.vue'

    import SupplierNameLabel from '@/components/hotels/snippets/SupplierNameLabel.vue'

    @Component({
        components: {ProductGallery, ProductGalleryMobile, SupplierNameLabel},
    })
    export class ItineraryInfo extends Vue {
        @Prop({required: true}) info
        @Prop({required: false, type: String}) supplierName

        get locale() {
            return this.$i18n.locale
        }

        get isTO1() {
            return authStore.isTO1
        }

        get includedInfo() {
            if (this.$route.name === 'order-details') return this.info.includedInfo?.[this.locale]

            return this.info.includedInfo?.[this.locale] || this.info.includedInfo
        }

        get notIncludedInfo() {
            if (this.$route.name === 'order-details') return this.info.notIncludedInfo?.[this.locale]

            return this.info.notIncludedInfo?.[this.locale] || this.info.notIncludedInfo
        }
    }

    export default ItineraryInfo
</script>
